import CopyIcon from '@flipster/react/icon/generated/CopyIcon';
import { WhalePosition } from '@flipster/socket/r230522/whale-position';
import { css } from '@flipster/styled-system/css';
import { center, hstack } from '@flipster/styled-system/patterns';
import { numberFormatter } from '@flipster/utils/num';

interface WhaleDetailsProps {
  whalePosition: WhalePosition;
  quoteCurrency: string;
  symbolPricePrecision: number;
  onCopyClick: (entryPrice: string) => void;
}

export const WhaleDetails = ({
  whalePosition,
  quoteCurrency,
  symbolPricePrecision,
  onCopyClick,
}: WhaleDetailsProps) => {
  return (
    <div
      className={css({
        display: 'grid',
        gap: 8,
        gridTemplateAreas: `
          "entry-label value-label"
          "entry-value value-value"`,
      })}
    >
      <div
        className={css({
          color: 'content.default.level-3',
          textStyle: 'Text/S/Regular',
          gridArea: 'entry-label',
          display: 'flex',
          alignItems: 'center',
        })}
      >
        Entry
      </div>
      <div
        className={css({
          color: 'content.default.level-3',
          textStyle: 'Text/S/Regular',
          gridArea: 'value-label',
          display: 'flex',
          alignItems: 'center',
        })}
      >
        Value ({quoteCurrency})
      </div>
      <button
        className={hstack({
          gap: 2,
          alignItems: 'center',
          gridArea: 'entry-value',
          _hover: {
            '& > div': {
              color: 'content.interaction.hover',
            },
          },
          _pressed: {
            '& > div': {
              color: 'content.interaction.hover',
            },
          },
        })}
        onClick={() => onCopyClick(whalePosition.entryPrice)}
      >
        <div
          className={css({
            color: 'content.default.level-4',
            textStyle: 'Text/S/Monospace/Underline',
          })}
        >
          {numberFormatter(whalePosition.entryPrice, {
            precision: symbolPricePrecision,
          })}
        </div>
        <div
          className={center({
            color: 'content.default.level-2',
            w: 16,
            h: 16,
          })}
        >
          <CopyIcon size={12} />
        </div>
      </button>
      <div
        className={css({
          color: 'content.default.level-4',
          textStyle: 'Text/S/Monospace/Regular',
          gridArea: 'value-value',
          display: 'flex',
          alignItems: 'center',
        })}
      >
        {numberFormatter(whalePosition.positionSize, {
          method: 'round-down',
          precision: 0,
        })}
      </div>
    </div>
  );
};
